/**
 * 处理投诉操作权限
 */
export const ORDER_COMPLAINT_ACTION_UUID =
  'b27d68b7-61fd-4032-aa3a-ccf065408409'
